import { getAuthTokenForHttpClientSync } from '@/utils/http/getAuthTokenForHttpClientSync';

export function getAuthToken(): string | undefined {
  return getAuthTokenForHttpClientSync() ?? undefined;
}
